module.exports = __webpack_public_path__ + "static/media/spa.dc5ff59d.png";